/**
 * WebApi
 *
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


export type VendorAttributeAnswerTypes = 'YesNo' | 'Text' | 'Number' | 'Money' | 'Document' | 'Hidden';

export const VendorAttributeAnswerTypes = {
    YesNo: 'YesNo' as VendorAttributeAnswerTypes,
    Text: 'Text' as VendorAttributeAnswerTypes,
    Number: 'Number' as VendorAttributeAnswerTypes,
    Money: 'Money' as VendorAttributeAnswerTypes,
    Document: 'Document' as VendorAttributeAnswerTypes,
    Hidden: 'Hidden' as VendorAttributeAnswerTypes
};

